<template>
  <div class="px-0 py-1">
    <editor-component :html="note" @done="save" />
  </div>
</template>

<script>
import { SLIDES_UPDATE_ACTIVE } from '@/config/constants';
import { mapState } from 'vuex';
import EditorComponent from '@/components/editor/EditorComponent';

export default {
  name: 'NoteComponent',
  components: { EditorComponent },
  computed: {
    ...mapState('slides', {
      note: state => state.active.note
    })
  },
  methods: {
    save(e) {
      this.$store.dispatch(SLIDES_UPDATE_ACTIVE, { note: e });
    }
  }
};
</script>

<style></style>
